import {getLayerByName, getLayerNamePrefix, getLayers} from "@/helpers/ol/ol-layer-helper";
import {getKVLayerByBookmarkPresentationID} from "@/helpers/kv/kv-layer-helper";
import {getPrintLayerWms} from "@/helpers/print/layers/print-layer-wms-helper";
import {getPrintLayerWmts} from "@/helpers/print/layers/print-layer-wmts-helper";
import {getPrintLayerWfs} from "@/helpers/print/layers/print-layer-wfs-helper";
import {getPrintLayerVector, getPrintLayerVectorByFeatures} from "@/helpers/print/layers/print-layer-vector-helper";
import {getMeasureFeatures, getToolsMeasureStyle} from "@/helpers/tools/tools-measure-helper";
import {Feature} from "ol";
import {getFilterMarkLayer} from "@/helpers/datatable-filter-helper";
import {getPrintLayer, getPrintStyle} from "@/helpers/print/print-scales-helper";
import {getGeoJsonLayers} from "@/helpers/ol/ol-geo-json-helper";
import {getDefaultStyle} from "ol/format/KML";
import {getPrintLayerXyz} from "@/helpers/print/layers/print-layer-xyz-helper";
import {getBySelector} from "@/helpers/element-helper";
import {rgbaToHex} from "@/helpers/color-helper.js";

/**
 * getPrintLayers()
 * @returns {[]}
 */
export function getPrintLayers() {

    const printLayers = []

    getLayers().forEach(layer => {

        const resolution = window.map.getView().getResolution()
        const visible =  layer.getVisible() && (
            resolution >= layer.getMinResolution() &&
            resolution < layer.getMaxResolution());

        if(visible) {
            let printLayer
            const kvLayer = getKVLayerByBookmarkPresentationID(layer.get('name').replace(getLayerNamePrefix(), ''))
            if (kvLayer) {
                switch (kvLayer.Type) {
                    case 'WMS':
                        printLayer = getPrintLayerWms(kvLayer)
                        printLayer.styles = [layer.getSource().getParams()['STYLES']]
                        break;
                    case 'WMTS':
                        printLayer = getPrintLayerWmts(kvLayer, layer)
                        break;
                    case 'WFS':
                        printLayer = getPrintLayerWfs(kvLayer, layer)
                        break;
                    case 'XYZ':
                        printLayer = getPrintLayerXyz(kvLayer)
                        break;
                    // case 'ArcGISMapServer':
                    //     printLayer = getPrintLayerXyz(kvLayer)
                    //     break;
                }

                if(printLayer) {

                    console.log(printLayer, layer.getZIndex())

                    printLayer.sorting = layer.getZIndex()
                    printLayer.opacity = layer.get('opacity')
                    printLayers.push(printLayer)
                }
            } else {
                // console.log(layer.get('name'))
                if(layer.get('name') === 'draw-measure' && layer.getSource().getFeatures().length > 0) {

                    printLayer = getPrintLayerVector(layer)

                    if(printLayer) {
                        printLayer.sorting = layer.getZIndex()
                        printLayer.opacity = layer.get('opacity')
                        printLayers.push(printLayer)
                    }
                }
            }
        }
    });

    let features = []
    let counter = 0

    // Measure features
    if(getBySelector('#chbPrintSegments').checked) {
        const measureFeatures = getMeasureFeatures()

        window.measurePrintFeatures.map((printFeature) => {
            printFeature.map(feature => {
                feature.set('key', counter)
                const style = {...getToolsMeasureStyle()}
                feature.set('style', style)
                features.push(feature)

                counter++
            })
        })

        measureFeatures.map((measureFeatures) => {

            measureFeatures.map((feature) => {

                feature.set('key', counter)
                const style = {...getToolsMeasureStyle()}
                feature.set('style', style)
                features.push(feature)

                counter++
            })
        })
    }

    // Filter marker features
    const filterMarkLayer = getFilterMarkLayer()
    if(filterMarkLayer) {
        filterMarkLayer.getSource().getFeatures().map((feature, key) => {
            feature.set('key', counter)
            features.push(feature)

            counter++
        })
    }

    if(getBySelector('#chbPrintFilterCounter').checked) {
        // Filter polygon
        const filterGeometryLayer = getLayerByName('draw-filter', false)
        if (filterGeometryLayer) {
            filterGeometryLayer.getSource().getFeatures().map((feature, key) => {
                feature.set('key', counter)
                feature.set('style', getPrintStyle())
                features.push(feature)

                counter++
            })
        }
    }

    const geoJsonLayers = getGeoJsonLayers()
    if(geoJsonLayers) {
        geoJsonLayers.map(layer => {
            layer.getSource().getFeatures().map((feature, key) => {

                const styleFunction = layer.getStyle();
                const style = typeof styleFunction === 'function' ? styleFunction(feature) : styleFunction;

                const singleStyle = Array.isArray(style) ? style[0] : style;

                const fill = singleStyle?.getFill?.() ?? singleStyle?.getImage?.()?.getFill?.();
                const fillColor = fill?.getColor?.();

                const stroke = style?.getStroke?.() ?? style?.getImage?.()?.getStroke?.();
                const strokeColor = stroke?.getColor?.();
                const strokeWidth = stroke.getWidth?.() ?? null;

                feature.set('style', {
                    strokeColor: rgbaToHex(strokeColor).hex,
                    strokeOpacity: rgbaToHex(strokeColor).opacity,
                    strokeWidth: strokeWidth,
                    fillColor: rgbaToHex(fillColor).hex,
                    fillOpacity: rgbaToHex(fillColor).opacity,
                })

                feature.set('key', counter)
                features.push(feature)

                counter++
            })
        })
    }

    if(features.length > 0) {
        const printLayer = getPrintLayerVectorByFeatures(features)
        printLayers.push(printLayer)
    }

    return printLayers
}
